// "My Top Movies" on a profile. The owner (MyProfile) sees their list — or an
// inviting empty state — with Edit / Share; visitors only ever receive a
// PUBLIC list from the API (`profile.topMovies`), so there is nothing private
// to hide here: no list means the section is omitted.
import { Link } from 'react-router-dom';
import TopMoviesGrid from './TopMoviesGrid';
import styles from './TopMovies.module.css';
import { ANALYTICS_EVENTS } from '../../analytics';
import { trackTopMovies } from '../../analytics/topMoviesAnalytics';

const trackProfileClick = (state) => trackTopMovies(ANALYTICS_EVENTS.TOP_MOVIES_CARD_CLICKED, { surface: 'profile', state, logged_in: true });

export default function TopMoviesProfileSection({ topMovies, isOwner = false, loading = false, className = '' }) {
    if (loading) return null;
    if (!topMovies) {
        if (!isOwner) return null;
        return (
            <section className={`${styles.profileCard} ${styles.emptyCard} ${className}`} aria-label="My Top Movies">
                <span className={styles.kicker}>My Top Movies 🎬</span>
                <h2 style={{ margin: 0 }}>Your movie taste deserves a spotlight.</h2>
                <p>Pick your all-time Top 5 and share it as a poster or a link.</p>
                <Link to="/top-movies" className={styles.primary} onClick={() => trackProfileClick('create')}>Create My Top Movies</Link>
            </section>
        );
    }

    const isPublic = Boolean(topMovies.shareSlug);
    return (
        <section className={`${styles.profileCard} ${className}`} aria-label="Top Movies">
            <div className={styles.profileHead}>
                <div>
                    <span className={styles.kicker}>{isOwner ? 'My Top Movies' : 'Top Movies'}</span>
                    <h2>All-Time Top {topMovies.size}</h2>
                </div>
                {isOwner && !isPublic && <span className={styles.hint}>Private — only you can see it</span>}
            </div>
            <TopMoviesGrid movies={topMovies.movies} ranked={topMovies.ranked} size={topMovies.size} compact />
            <div className={styles.buttonRow}>
                {isPublic && <Link to={`/top-movies/${topMovies.shareSlug}`} className={styles.secondary}>View Full List</Link>}
                {isOwner && <Link to="/top-movies" className={isPublic ? styles.ghost : styles.primary} onClick={() => trackProfileClick('edit')}>Edit My Top Movies</Link>}
                {isPublic && <Link to={`/top-movies/${topMovies.shareSlug}`} className={styles.ghost} state={{ share: true }}>Share</Link>}
            </div>
        </section>
    );
}
